<template>
    <v-dialog v-model="show" width="800px">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t("lang.common.select")}}</v-toolbar-title>
            </v-toolbar>
            <div style="padding: 10px">
                <v-data-table style="width:100%" :headers="headers"
                              :items="items" :rows-per-page-items="rowsPerPageItems">
                    <template slot="headers">
                        <th style="text-align: left">
                            <v-checkbox v-if="multiSelect=='true'" color="primary" hide-details
                                        v-model="selectAll" @change="onSelectAll"></v-checkbox>
                            <div v-else>
                                {{$t("lang.common.select")}}
                            </div>
                        </th>
                        <th v-for="header in headers" :width="header.width" style="text-align: left">
                            <div>
                                {{$t(header.text)}}
                            </div>
                        </th>
                    </template>
                    <template v-slot:items="props">
                        <td>
                            <v-checkbox v-model="props.item['check']" color="primary" hide-details
                                        @change="onSelectItem(props.item['check'],props.item[valueField])"
                            ></v-checkbox>
                        </td>
                        <td v-for="header in headers">
                            <div>
                                {{props.item[header.value]}}
                            </div>
                        </td>
                    </template>
                </v-data-table>
                <div style="text-align: right">
                    <v-btn color="primary" dark @click="onApply">
                        <v-icon dark left>save</v-icon>
                        {{$t('lang.common.select')}}
                    </v-btn>
                    <v-btn color="error" dark @click="onCancel">
                        <v-icon dark left>arrow_back</v-icon>
                        {{$t('lang.common.back')}}
                    </v-btn>
                </div>
            </div>
        </v-card>
    </v-dialog>

</template>

<script>
    import Validator from "../../../public/js/validator";
    import axios from "axios";
    import VueController from "../../../public/js/controller";

    const v = Validator();

    export default {
        name: 'i-select-data',
        components: {Validator},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'Manager'
            },
            column: {
                type: String,
                default: "12"
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            }
        },
        watch: {
            show: function (value) {
                if (value == false) {
                    this.$emit("onclose");
                }

            }
        },

        created() {
            VueController.push(this);
        },

        destroyed() {
            VueController.removeComponentByEl(this);
        },

        data: () => {
            return {
                values: {},
                model: {},
                show: false,
                sql: null,
                items: [],
                headers: [],
                valueField: null,
                selectedData: null,
                multiSelect: true,
                selectAll: false
            }
        },
        methods: {
            onApply: function () {
                let values = "";
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i]["check"]) {
                        if (values == "") {
                            values = this.items[i][this.valueField];
                        } else {
                            values = values + "," + this.items[i][this.valueField];
                        }
                    }
                }
                if (values == "") {
                    alert(this.$t("lang.common.select_one"));
                } else {
                    this.$emit("onselect", values);
                    this.show = false;
                }
            },

            loadData: function (sql, valueField, selectedData, multiSelect) {
                this.show = true;
                this.selectedData = selectedData;
                this.valueField = valueField;
                this.multiSelect = multiSelect;
                console.log("multiselect:" + multiSelect);
                sql = encodeURI(sql);
                axios.post(process.env.VUE_APP_API_URL + "/workflow/getdata?sql=" + sql).then(data => {
                        if (data.length > 0) {
                            let ob = data[0];
                            let fields = [];
                            for (let key in ob) {
                                let field = {text: key, value: key, order: false};
                                fields.push(field);
                            }
                            this.headers = fields;
                            let valueList = this.selectedData.split(",");
                            console.log(valueList);

                            if(valueList.length > 0) {
                                for (let i = 0; i < data.length; i++) {
                                    for (let j = 0; j < valueList.length; j++) {
                                        if (data[i][this.valueField] == valueList[j]) {
                                            data[i]["check"] = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            this.items = data;
                        }
                    },
                    error => {

                    }
                );
            },

            onView: function (value) {
                this.values = value;
            },

            onSelectItem: function (check, value) {
                console.log(check + "-" + value);
                if (check == true) {
                    console.log("check==true");
                    console.log(this.multiSelect);

                    if (this.multiSelect == "false") {
                        console.log("here");
                        for (let i = 0; i < this.items.length; i++) {
                            if (this.items[i]["check"] == true && this.items[i][this.valueField] != value) {
                                this.items[i]["check"] = false;
                            } else {
                                console.log(this.items[i][this.valueField]);
                            }
                        }
                    }
                } else {
                    if (this.selectAll == true) {
                        this.selectAll = false;
                    }
                }
            },

            onSelectAll: function () {
                for (let i = 0; i < this.items.length; i++) {
                    this.items[i]["check"] = this.selectAll;
                }
            },

            onUnSelectItem: function () {
            },

            onCancel: function () {
                this.show = false;
            }
        }
    }
</script>
